import isEmptyObject from '#shared/util/isEmptyObject.js';

/**
 * Initialization push
 * @param {object} cart
 * @returns {object}
 */
export default (cart) => {
	const aswparamObject = cart.order.aswparam.object;
	const isAccountObjectEmpty = isEmptyObject(cart.account);
	return {
		client: {
			cmpId: cart.theme.tracking.consentId,
			deviceId: '-', // do not send unless we have a server-side generated ID
			myAccountStatus: !isAccountObjectEmpty ? cart.account.status.myAccount : '',
			paired: !isAccountObjectEmpty ? cart.account.status.paired : '',
			myAccountId: !isAccountObjectEmpty ? cart.account.status.MyAccountID : ''
		},
		session: {
			countryCode: cart.url.region,
			ip: '-',
			secChUa: navigator.userAgentData ? navigator.userAgentData.brands : [],
			platform: navigator.userAgentData ? navigator.userAgentData.platform : '',
			mobile: navigator.userAgentData ? navigator.userAgentData.mobile : '-',
			flow_id: aswparamObject.flow_id,
			guid: aswparamObject.p_hid,
			aiid: aswparamObject.p_bld,
			ipm_product: aswparamObject.p_pro
		},
		server: {
			provider: cart.theme.provider.name,
			platform: cart.theme.name,
			env: cart.app.env,
			dataCenter: cart.app.session.origin,
			sdlVersion: cart.theme.tracking.sdlVersion
		},
		consentGroups: cart.theme.tracking.consentGroups || ''
	};
};
